import { render, staticRenderFns } from "./validator-phone.vue?vue&type=template&id=1b8194d8&scoped=true&"
import script from "./validator-phone.vue?vue&type=script&lang=js&"
export * from "./validator-phone.vue?vue&type=script&lang=js&"
import style0 from "./validator-phone.vue?vue&type=style&index=0&id=1b8194d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8194d8",
  null
  
)

export default component.exports